import Auth from '@js/plugins/auth';

export default {
    computed: {
        canManageItems() {
            return Auth.hasPermissionTo('franchise_manage_items');
        },
        readOnlyItems() {
            return Auth.hasPermissionTo('admin_read_only_system');
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/item-permission.js